import React, { useContext } from "react"
import { useParams } from "react-router-dom"
import { FeatureCatalogContext } from "../../../../../../features/FeatureCatalogViewer/FeatureCatalogProvider"
import "./Properties.scss"

const Properties = () => {
  const context = useContext(FeatureCatalogContext)
  const { pid } = useParams<{ catalog: string; type: string; pid: string }>()

  return (
    <div>
      <table id="table" className="table table-borderless">
        <thead>
          <tr>
            <th className="card-subtitle-2" id="headerInPanel" colSpan={2}>
              PROPERTIES
            </th>
          </tr>
        </thead>
        <tbody id="body">
          <tr>
            <th id="item" scope="row" className="card-subtitle-1 align-top">
              PID
            </th>
            <td id="value" className="card-text-1">
              {pid}
            </td>
          </tr>
          <tr>
            <th id="item" scope="row" className="card-subtitle-1 align-top">
              Short name
            </th>
            <td id="value" className="card-text-1">
              {context.elementDetails ? (context.elementDetails.shortName ? context.elementDetails.shortName : "") : ""}
            </td>
          </tr>
          <tr>
            <th id="item" scope="row" className="card-subtitle-1 align-top">
              Description
            </th>
            <td id="value" className="card-text-1">
              {context.elementDetails ? context.elementDetails.description : ""}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default Properties
